module.exports = __webpack_public_path__ + "static/media/sushiKooMenu.8f6df376.pdf";